
const maps = document.querySelectorAll(".map");
		
maps.forEach(element => {
	const	lat = parseFloat(element.getAttribute("data-lat")),
			lng = parseFloat(element.getAttribute("data-lng")),
			marker = element.getAttribute("data-marker-path"),
			name_marker = element.getAttribute("data-name"),
			zoom = element.getAttribute("data-zoom"),
			coord = [lat, lng];
	
	if (element) {
				document.addEventListener("DOMContentLoaded", function () {
					var map = L.map(element, {
						center: coord,
						zoom: zoom,
					});
					
					var myIcon = L.icon({
						iconUrl: marker,
						iconSize: [30, 40],
						iconAnchor: [15, 40],
							className: 'map_marker',
					});
					
					var tiles = L.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw", {
						maxZoom: 18,
						minZoom: 5,
						attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' + 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						id: "mapbox/light-v10",
						tileSize: 512,
						zoomOffset: -1,
					}).addTo(map);
			
					L.marker(coord, {
						title: name_marker,
						alt: name_marker,
			
						icon: myIcon,
					}).addTo(map);
			
				});
				// initialize the map on the "map" div with a given center and zoom
	}
});

